module.exports = __webpack_public_path__ + "static/media/Rollen-Handtuecher.bc37987c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Rollen-Handtuecher.png
// module id = 137
// module chunks = 0